module.exports = __webpack_public_path__ + "img/cellphone.49ded015.png";